import { render, staticRenderFns } from "./PortalParentFolders.vue?vue&type=template&id=4f31be72&scoped=true&"
import script from "./PortalParentFolders.vue?vue&type=script&lang=js&"
export * from "./PortalParentFolders.vue?vue&type=script&lang=js&"
import style0 from "./PortalParentFolders.vue?vue&type=style&index=0&id=4f31be72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f31be72",
  null
  
)

export default component.exports